export const signatureQueryKeys = {
  all: ['signature'] as const,
  // Tenant-scoped: with Fase 1 ("Firma per sede") a signature is per (user,
  // tenant), not per user — an unscoped key would serve tenant A's signature
  // to tenant B after a switch, until the next unrelated refetch.
  me: (tenantId: string) => ['signature', 'me', tenantId] as const,
};
